import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getAllDocsSnap, addNewDoc } from "../../utils/firebase/Firebase.utils";
import MobileWrapper from "../../components/MobileWrapper";
import Select from "react-select";
import {
  FiBox,
  FiPackage,
  FiCalendar,
  FiSearch,
  FiUser,
  FiTag,
  FiMap,
  FiPlusCircle,
  FiFileText,
  FiXCircle,
  FiTrendingUp,
  FiTrendingDown,
  FiArrowRight,
  FiCheckCircle,
  FiAlignLeft,
  FiHash,
  FiSave,
  FiX,
  FiPlus,
} from "react-icons/fi";
import toast from "react-hot-toast";

// Helper function to calculate balance from transactions
const calculateItemBalance = (transactions, itemId) => {
  let additions = 0;
  let issuances = 0;

  const itemTransactions = transactions.filter((t) => t.itemId === itemId);
  console.log(itemTransactions);

  itemTransactions.forEach((transaction) => {
    if (transaction.transactionType === "addition") {
      additions += parseInt(transaction.quantity) || 0;
    } else if (transaction.transactionType === "issuance") {
      issuances += parseInt(transaction.quantity) || 0;
    }
  });

  console.log(additions);

  return {
    additions,
    issuances,
    balance: additions - issuances,
  };
};

function InventoryMobile() {
  const currentUser = useSelector((state) => state.userObject);
  const [activeTab, setActiveTab] = useState("purchases");
  const [showAddModal, setShowAddModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [inventoryItems, setInventoryItems] = useState([]);
  const [issuances, setIssuances] = useState([]);
  const [issuancesToMe, setIssuancesToMe] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    department: currentUser.roles[0],
  });
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [issuanceFormData, setIssuanceFormData] = useState({});
  const [issuanceProcessing, setIssuanceProcessing] = useState(false);
  const [itemTransactions, setItemTransactions] = useState([]);
  const [itemBalance, setItemBalance] = useState(0);
  const [adminUsers, setAdminUsers] = useState([]);
  const [issuedToUsers, setIssuedToUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [itemBalances, setItemBalances] = useState({});

  // Colors based on requirements
  const primaryColor = "#363062";
  const secondaryColor = "#8FCD00";

  useEffect(() => {
    const fetchInventoryData = async () => {
      setLoading(true);
      // Fetch all transactions first to calculate balances
      let allTransactions = [];
      await getAllDocsSnap("inventoryTransactions", (transactionsData) => {
        allTransactions = transactionsData || [];

        // Now fetch inventory items
        getAllDocsSnap("inventory", (data) => {
          const userItems = data.filter(
            (item) => item.createdEmail === currentUser.email
          );

          // Sort by date (newest first)
          userItems.sort((a, b) => {
            const dateA = new Date(a.createdAt).getTime();
            const dateB = new Date(b.createdAt).getTime();
            return dateB - dateA;
          });

          // Calculate balances for all items
          const balances = {};
          userItems.forEach((item) => {
            balances[item.id] = calculateItemBalance(allTransactions, item.id);
          });

          console.log("balances", balances);

          setItemBalances(balances);
          setInventoryItems(userItems);

          // After getting inventory items, fetch issuances
          fetchIssuances(allTransactions);
        });
      });
    };

    const fetchIssuances = async (transactions) => {
      // Filter transactions for issuances only and created by the current user
      const userIssuances = transactions.filter((transaction) => {
        return (
          transaction.transactionType === "issuance" &&
          transaction.userEmail === currentUser.email
        );
      });

      // Sort by date, newest first
      userIssuances.sort((a, b) => {
        const dateA = new Date(a.date || a.createdAt).getTime();
        const dateB = new Date(b.date || b.createdAt).getTime();
        return dateB - dateA;
      });

      // Filter transactions for issuances to the current user
      const issuedToCurrentUser = transactions.filter((transaction) => {
        // Skip if not an issuance
        if (transaction.transactionType !== "issuance") return false;

        // If user is one of the recipients in issuedToUsers array
        if (
          transaction.issuedToUsers &&
          transaction.issuedToUsers.some(
            (user) => user.value === currentUser.email
          )
        ) {
          return true;
        }

        // If the user's name or email is mentioned in issuedTo field
        if (
          transaction.issuedTo &&
          (transaction.issuedTo.includes(currentUser.displayName) ||
            transaction.issuedTo.includes(currentUser.email))
        ) {
          return true;
        }

        return false;
      });

      // Sort issuances to user by date, newest first
      issuedToCurrentUser.sort((a, b) => {
        const dateA = new Date(a.date || a.createdAt).getTime();
        const dateB = new Date(b.date || b.createdAt).getTime();
        return dateB - dateA;
      });

      setIssuances(userIssuances);
      setIssuancesToMe(issuedToCurrentUser);
      setLoading(false);

      // Recalculate balances for all items
      // const updatedBalances = { ...itemBalances };
      // console.log("updatedbalances", updatedBalances)
      // for (const id in updatedBalances) {
      //   updatedBalances[id] = calculateItemBalance(transactions, id);
      // }
      // setItemBalances(updatedBalances);
    };

    fetchInventoryData();
  }, [currentUser.email]);

  // Apply search filter
  const filteredItems = inventoryItems.filter(
    (item) =>
      item.itemName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.location?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.custodian?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.category?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredIssuances = issuances.filter(
    (issuance) =>
      issuance.itemName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      issuance.issuedTo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      issuance.purpose?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredIssuancesToMe = issuancesToMe.filter(
    (issuance) =>
      issuance.itemName
        ?.toLowerCase()
        .includes(searchTerm?.toLowerCase() || "") ||
      issuance.issuedTo
        ?.toLowerCase()
        .includes(searchTerm?.toLowerCase() || "") ||
      issuance.purpose
        ?.toLowerCase()
        .includes(searchTerm?.toLowerCase() || "") ||
      (issuance.user &&
        issuance.user.toLowerCase().includes(searchTerm?.toLowerCase() || ""))
  );

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.itemName || !formData.quantity || !formData.location) {
      toast.error("Please fill in all required fields");
      return;
    }

    setIsProcessing(true);
    const docObject = {
      ...formData,
      department: formData.department || currentUser.roles[0],
      quantity: parseInt(formData.quantity) || 0,
      status: "Available",
      createdAt: new Date().toLocaleString(),
      createdBy: currentUser.uid,
      createdName: currentUser.displayName,
      createdEmail: currentUser.email,
      updateType: "new inventory item created",
    };

    try {
      // Add new inventory item
      const newItemRef = await addNewDoc("inventory", docObject);

      // Create a corresponding transaction record for the initial quantity
      const transactionObject = {
        itemId: newItemRef.id,
        itemName: formData.itemName,
        quantity: parseInt(formData.quantity) || 0,
        department: formData.department || currentUser.roles[0],

        transactionType: "addition",
        user: currentUser.displayName,
        userId: currentUser.uid,
        userEmail: currentUser.email,
        createdAt: new Date().toLocaleString(),
        date: new Date().toLocaleDateString(),
        remarks: "Initial inventory addition",
        updateType: "inventory addition",
      };

      // Add category if it exists
      if (formData.category) {
        transactionObject.category = formData.category;
      }

      // Add cost per unit if it exists
      if (formData.costPerUnit) {
        transactionObject.costPerUnit = formData.costPerUnit;
      }

      // Create the transaction record
      await addNewDoc("inventoryTransactions", transactionObject);

      toast.success("New Inventory Item Successfully Created");
      setShowAddModal(false);
      setFormData({});

      // Refresh the inventory list
      await getAllDocsSnap("inventory", (data) => {
        const userItems = data.filter(
          (item) => item.createdEmail === currentUser.email
        );

        userItems.sort((a, b) => {
          const dateA = new Date(a.createdAt).getTime();
          const dateB = new Date(b.createdAt).getTime();
          return dateB - dateA;
        });

        setInventoryItems(userItems);
      });
    } catch (error) {
      toast.error("Error creating inventory item");
      console.error("Error creating inventory:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  // Handle card click to view details
  const handleViewItemDetails = async (item) => {
    setSelectedItem(item);
    setShowDetailModal(true);
    setIssuanceFormData({});
    setLoadingUsers(true);

    // Fetch transactions for this item
    await getAllDocsSnap("inventoryTransactions", (data) => {
      // Filter for this item only and calculate balance
      const itemTxns = data.filter(
        (transaction) => transaction.itemId === item.id
      );

      // Sort by date, newest first
      itemTxns.sort((a, b) => {
        const dateA = new Date(a.date || a.createdAt).getTime();
        const dateB = new Date(b.date || b.createdAt).getTime();
        return dateB - dateA;
      });

      setItemTransactions(itemTxns);

      // Calculate balance
      const balanceData = calculateItemBalance(data, item.id);
      setItemBalance(balanceData.balance);
    });

    // Fetch admin users for the dropdown
    await getAllDocsSnap("users", (userData) => {
      const filteredUsers = userData.filter(
        (user) => !user.roles?.includes("user")
      );
      setAdminUsers(filteredUsers);
      setLoadingUsers(false);
    });
  };

  // Handle issuance form change
  const handleIssuanceChange = (e) => {
    const { name, value } = e.target;
    setIssuanceFormData({ ...issuanceFormData, [name]: value });
  };

  // Handle user selection change
  const handleSelectedUserChange = (selected) => {
    setIssuedToUsers(selected || []);
  };

  // Handle issuance submission
  const handleIssuanceSubmit = async (e) => {
    e.preventDefault();

    if (
      !issuanceFormData.quantity ||
      !issuanceFormData.purpose ||
      issuedToUsers.length === 0
    ) {
      toast.error("Please fill in all required fields");
      return;
    }

    if (Number(issuanceFormData.quantity) > itemBalance) {
      toast.error("Cannot issue more than available balance");
      return;
    }

    setIssuanceProcessing(true);

    const issuanceObj = {
      ...issuanceFormData,
      transactionType: "issuance",
      itemId: selectedItem.id,
      itemName: selectedItem.itemName,
      quantity: parseInt(issuanceFormData.quantity) || 0,
      user: currentUser.displayName,
      userId: currentUser.uid,
      userEmail: currentUser.email,
      createdAt: new Date().toLocaleString(),
      date: issuanceFormData.date || new Date().toLocaleDateString(),
      updateType: "issuance of inventory",
      issuedTo: issuedToUsers.map((user) => user.label).join(", "),
      issuedToUsers: issuedToUsers,
    };

    // Add category if it exists
    if (selectedItem.category) {
      issuanceObj.category = selectedItem.category;
    }

    try {
      await addNewDoc("inventoryTransactions", issuanceObj);
      toast.success("Item issued successfully");

      // Refresh transactions
      await getAllDocsSnap("inventoryTransactions", (data) => {
        // Filter for this item only
        const itemTransactions = data.filter(
          (transaction) => transaction.itemId === selectedItem.id
        );

        // Sort by date, newest first
        itemTransactions.sort((a, b) => {
          const dateA = new Date(a.date || a.createdAt).getTime();
          const dateB = new Date(b.date || b.createdAt).getTime();
          return dateB - dateA;
        });

        setItemTransactions(itemTransactions);

        // Recalculate the balance
        const { additions, issuances, balance } = calculateItemBalance(
          data,
          selectedItem.id
        );
        setItemBalance(balance);
      });

      // Refresh the issuances lists and balances
      await getAllDocsSnap("inventoryTransactions", (data) => {
        // Update My Issuances tab
        const userIssuances = data.filter((transaction) => {
          return (
            transaction.transactionType === "issuance" &&
            transaction.userEmail === currentUser.email
          );
        });

        userIssuances.sort((a, b) => {
          const dateA = new Date(a.date || a.createdAt).getTime();
          const dateB = new Date(b.date || b.createdAt).getTime();
          return dateB - dateA;
        });

        // Update Issued to Me tab
        const issuedToCurrentUser = data.filter((transaction) => {
          if (transaction.transactionType !== "issuance") return false;

          if (
            transaction.issuedToUsers &&
            transaction.issuedToUsers.some(
              (user) => user.value === currentUser.email
            )
          ) {
            return true;
          }

          if (
            transaction.issuedTo &&
            (transaction.issuedTo.includes(currentUser.displayName) ||
              transaction.issuedTo.includes(currentUser.email))
          ) {
            return true;
          }

          return false;
        });

        issuedToCurrentUser.sort((a, b) => {
          const dateA = new Date(a.date || a.createdAt).getTime();
          const dateB = new Date(b.date || b.createdAt).getTime();
          return dateB - dateA;
        });

        setIssuances(userIssuances);
        setIssuancesToMe(issuedToCurrentUser);

        // Recalculate balances for all items
        const updatedBalances = { ...itemBalances };
        for (const id in updatedBalances) {
          updatedBalances[id] = calculateItemBalance(data, id);
        }
        setItemBalances(updatedBalances);
      });

      // Clear form
      setIssuanceFormData({});
    } catch (error) {
      toast.error("Failed to issue item");
      console.error(error);
    } finally {
      setIssuanceProcessing(false);
    }
  };

  // Clear form state when closing modal
  const handleCloseDetailModal = () => {
    setShowDetailModal(false);
    setSelectedItem(null);
    setIssuanceFormData({});
    setIssuedToUsers([]);
    setItemTransactions([]);
  };

  if (loading) {
    return (
      <MobileWrapper label="Inventory Management">
        <div className="flex justify-center items-center h-64">
          <div className="text-center">
            <div
              className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2"
              style={{ borderColor: primaryColor }}
            ></div>
            <p className="mt-2 text-sm" style={{ color: primaryColor }}>
              Loading inventory data...
            </p>
          </div>
        </div>
      </MobileWrapper>
    );
  }

  console.log("itembalances", itemBalances);

  return (
    <MobileWrapper label="Inventory Management">
      <div className="w-full mx-auto px-4 max-w-4xl">
        {/* Header Section */}
        <div className="flex items-center justify-between mb-6 bg-[#363062]/5 p-4 rounded-lg">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-[#363062] rounded-lg">
              <FiBox className="text-white text-base" />
            </div>
            <div>
              <h1 className="text-sm font-medium text-[#363062]">
                Inventory Management
              </h1>
              <p className="text-xs text-gray-500">
                Record and view your inventory items
              </p>
            </div>
          </div>
          <button
            onClick={() => setShowAddModal(true)}
            className="p-2 rounded-full bg-[#8FCD00] text-white"
          >
            <FiPlusCircle className="text-base" />
          </button>
        </div>

        {/* Tabs Navigation */}
        <div className="flex mb-4 bg-gray-100 rounded-lg p-1">
          <button
            className={`flex-1 py-2 px-2 rounded-md text-xs font-medium ${
              activeTab === "purchases"
                ? "bg-[#363062] text-white"
                : "text-gray-600"
            }`}
            onClick={() => setActiveTab("purchases")}
          >
            My Purchases
          </button>
          <button
            className={`flex-1 py-2 px-2 rounded-md text-xs font-medium ${
              activeTab === "issuances"
                ? "bg-[#363062] text-white"
                : "text-gray-600"
            }`}
            onClick={() => setActiveTab("issuances")}
          >
            My Issuances
          </button>
          <button
            className={`flex-1 py-2 px-2 rounded-md text-xs font-medium ${
              activeTab === "issuedToMe"
                ? "bg-[#363062] text-white"
                : "text-gray-600"
            }`}
            onClick={() => setActiveTab("issuedToMe")}
          >
            Issued to Me
          </button>
        </div>

        {/* Search Bar */}
        <div className="relative mb-4">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <FiSearch className="w-3.5 h-3.5 text-gray-500" />
          </div>
          <input
            type="text"
            className="block w-full p-2.5 pl-10 text-xs border rounded-lg bg-gray-50 focus:outline-none focus:ring-1 focus:ring-[#363062] focus:border-[#363062]"
            placeholder={
              activeTab === "purchases"
                ? "Search items, locations, or categories..."
                : activeTab === "issuances"
                ? "Search items, purposes, or recipients..."
                : "Search items, purposes, or issuers..."
            }
            value={searchTerm}
            onChange={handleSearch}
            style={{ borderColor: "#E2E8F0" }}
          />
          {searchTerm && (
            <button
              className="absolute inset-y-0 right-0 flex items-center pr-3"
              onClick={() => setSearchTerm("")}
            >
              <FiXCircle className="w-3.5 h-3.5 text-gray-500" />
            </button>
          )}
        </div>

        {/* Inventory Purchases Tab Content */}
        {activeTab === "purchases" && (
          <div className="mt-4 space-y-3">
            {filteredItems.length === 0 ? (
              <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-100">
                <div className="p-3 bg-[#363062]/10 rounded-full w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <FiPackage className="text-[#363062] text-lg" />
                </div>
                <h3 className="text-sm font-medium text-[#363062] mb-1">
                  {inventoryItems.length === 0
                    ? "No Inventory Records"
                    : "No Matching Results"}
                </h3>
                <p className="text-xs text-gray-500">
                  {inventoryItems.length === 0
                    ? "You haven't recorded any inventory items yet"
                    : "Try adjusting your search terms"}
                </p>
              </div>
            ) : (
              filteredItems.map((item) => (
                <div
                  key={item.id}
                  className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden transition-all hover:shadow-md cursor-pointer"
                  onClick={() => handleViewItemDetails(item)}
                >
                  <div className="p-4">
                    <div className="flex justify-between items-start mb-2">
                      <div className="text-sm font-medium text-[#363062]">
                        {item.itemName || "Unknown Item"}
                      </div>
                      <div
                        className="flex items-center px-2 py-1 rounded-full text-xs font-medium gap-1.5"
                        style={{
                          backgroundColor: `${secondaryColor}15`,
                          color: secondaryColor,
                        }}
                      >
                        <span className="text-xs">
                          <FiPackage />
                        </span>
                        {item.quantity} units
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-2 text-xs text-gray-600 mb-3">
                      <div className="flex items-center gap-1.5">
                        <FiCalendar className="text-gray-400 flex-shrink-0" />
                        <span>{formatDate(item.createdAt)}</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <FiTag className="text-gray-400 flex-shrink-0" />
                        <span>{item.category || "No category"}</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <FiMap className="text-gray-400 flex-shrink-0" />
                        <span>{item.location || "No location"}</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <FiUser className="text-gray-400 flex-shrink-0" />
                        <span>{item.custodian || "No custodian"}</span>
                      </div>
                    </div>

                    {/* Balance indicator */}
                    <div className="flex justify-between items-center mb-2 pt-2 border-t border-gray-100">
                      <div className="text-xs text-gray-500">
                        Current Balance:
                      </div>
                      <div
                        className="flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium"
                        style={{
                          backgroundColor: `${
                            itemBalances[item.id]?.balance > 0
                              ? secondaryColor
                              : "#ef4444"
                          }15`,
                          color:
                            itemBalances[item.id]?.balance > 0
                              ? secondaryColor
                              : "#ef4444",
                        }}
                      >
                        {itemBalances[item.id]?.balance > 0 ? (
                          <FiTrendingUp className="w-3 h-3" />
                        ) : (
                          <FiTrendingDown className="w-3 h-3" />
                        )}
                        <span>{itemBalances[item.id]?.balance || 0} units</span>
                      </div>
                    </div>

                    {/* Description Section (if any) */}
                    {item.description && (
                      <div className="mt-2 pt-2 border-t border-gray-100">
                        <div className="text-xs text-gray-500 mb-1.5">
                          Description:
                        </div>
                        <div className="text-xs text-gray-600">
                          {item.description}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* Inventory Issuances Tab Content */}
        {activeTab === "issuances" && (
          <div className="mt-4 space-y-3">
            {filteredIssuances.length === 0 ? (
              <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-100">
                <div className="p-3 bg-[#363062]/10 rounded-full w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <FiPackage className="text-[#363062] text-lg" />
                </div>
                <h3 className="text-sm font-medium text-[#363062] mb-1">
                  {issuances.length === 0
                    ? "No Issuance Records"
                    : "No Matching Results"}
                </h3>
                <p className="text-xs text-gray-500">
                  {issuances.length === 0
                    ? "You haven't issued any inventory items yet"
                    : "Try adjusting your search terms"}
                </p>
              </div>
            ) : (
              filteredIssuances.map((issuance) => (
                <div
                  key={issuance.id}
                  className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden transition-all hover:shadow-md"
                >
                  <div className="p-4">
                    <div className="flex justify-between items-start mb-2">
                      <div className="text-sm font-medium text-[#363062]">
                        {issuance.itemName || "Unknown Item"}
                      </div>
                      <div
                        className="flex items-center px-2 py-1 rounded-full text-xs font-medium gap-1.5"
                        style={{
                          backgroundColor: `${secondaryColor}15`,
                          color: secondaryColor,
                        }}
                      >
                        <span className="text-xs">
                          <FiPackage />
                        </span>
                        {issuance.quantity} units
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-2 text-xs text-gray-600 mb-3">
                      <div className="flex items-center gap-1.5">
                        <FiCalendar className="text-gray-400 flex-shrink-0" />
                        <span>
                          {formatDate(issuance.date || issuance.createdAt)}
                        </span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <FiUser className="text-gray-400 flex-shrink-0" />
                        <span>{issuance.user || "Unknown"}</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <FiTag className="text-gray-400 flex-shrink-0" />
                        <span>
                          {issuance.purpose || "No purpose specified"}
                        </span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <FiFileText className="text-gray-400 flex-shrink-0" />
                        <span>
                          {issuance.issuedTo || "No recipient specified"}
                        </span>
                      </div>
                    </div>

                    {/* Remarks Section (if any) */}
                    {issuance.remarks && (
                      <div className="mt-2 pt-2 border-t border-gray-100">
                        <div className="text-xs text-gray-500 mb-1.5">
                          Remarks:
                        </div>
                        <div className="text-xs text-gray-600">
                          {issuance.remarks}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* Issued to Me Tab Content */}
        {activeTab === "issuedToMe" && (
          <div className="mt-4 space-y-3">
            {filteredIssuancesToMe.length === 0 ? (
              <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-100">
                <div className="p-3 bg-[#363062]/10 rounded-full w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <FiPackage className="text-[#363062] text-lg" />
                </div>
                <h3 className="text-sm font-medium text-[#363062] mb-1">
                  {issuancesToMe.length === 0
                    ? "No Items Issued to You"
                    : "No Matching Results"}
                </h3>
                <p className="text-xs text-gray-500">
                  {issuancesToMe.length === 0
                    ? "No inventory items have been issued to you yet"
                    : "Try adjusting your search terms"}
                </p>
              </div>
            ) : (
              filteredIssuancesToMe.map((issuance) => (
                <div
                  key={issuance.id}
                  className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden transition-all hover:shadow-md"
                >
                  <div className="p-4">
                    <div className="flex justify-between items-start mb-2">
                      <div className="text-sm font-medium text-[#363062]">
                        {issuance.itemName || "Unknown Item"}
                      </div>
                      <div
                        className="flex items-center px-2 py-1 rounded-full text-xs font-medium gap-1.5"
                        style={{
                          backgroundColor: `${secondaryColor}15`,
                          color: secondaryColor,
                        }}
                      >
                        <span className="text-xs">
                          <FiPackage />
                        </span>
                        {issuance.quantity} units
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-2 text-xs text-gray-600 mb-3">
                      <div className="flex items-center gap-1.5">
                        <FiCalendar className="text-gray-400 flex-shrink-0" />
                        <span>
                          {formatDate(issuance.date || issuance.createdAt)}
                        </span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <FiUser className="text-gray-400 flex-shrink-0" />
                        <span>{issuance.user || "Unknown"}</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <FiTag className="text-gray-400 flex-shrink-0" />
                        <span>
                          {issuance.purpose || "No purpose specified"}
                        </span>
                      </div>
                    </div>

                    {/* Remarks Section (if any) */}
                    {issuance.remarks && (
                      <div className="mt-2 pt-2 border-t border-gray-100">
                        <div className="text-xs text-gray-500 mb-1.5">
                          Remarks:
                        </div>
                        <div className="text-xs text-gray-600">
                          {issuance.remarks}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* Add New Inventory Modal */}
        {showAddModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center p-4 border-b border-gray-100">
                <div className="flex items-center gap-2">
                  <div
                    className="p-2 rounded-lg"
                    style={{ backgroundColor: `${primaryColor}10` }}
                  >
                    <FiPackage style={{ color: primaryColor }} />
                  </div>
                  <h2
                    className="text-base font-semibold"
                    style={{ color: primaryColor }}
                  >
                    Add New Inventory Item
                  </h2>
                </div>
                <button
                  onClick={() => setShowAddModal(false)}
                  className="p-2 rounded-full hover:bg-gray-100 transition-colors"
                >
                  <FiX className="text-gray-500" />
                </button>
              </div>

              <div className="p-4 space-y-4">
                <div className="text-sm text-gray-500 mb-2 font-medium">
                  Item Information
                </div>

                <div className="flex gap-2 items-center w-full">
                  <div className="text-gray-400 self-start pt-2">
                    <FiBox size={16} />
                  </div>
                  <div className="w-full">
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Item Name *
                    </label>
                    <input
                      type="text"
                      name="itemName"
                      placeholder="Enter item name"
                      onChange={handleChange}
                      value={formData.itemName || ""}
                      required
                      disabled={isProcessing}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                    />
                  </div>
                </div>

                <div className="flex gap-2 items-center w-full">
                  <div className="text-gray-400 self-start pt-2">
                    <FiTag size={16} />
                  </div>
                  <div className="w-full">
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Category
                    </label>
                    <input
                      type="text"
                      name="category"
                      placeholder="Enter item category"
                      onChange={handleChange}
                      value={formData.category || ""}
                      disabled={isProcessing}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                    />
                  </div>
                </div>

                <div className="flex gap-2 items-center w-full">
                  <div className="text-gray-400 self-start pt-2">
                    <FiTag size={16} />
                  </div>
                  <div className="w-full">
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Department
                    </label>
                    <input
                      type="text"
                      name="department"
                      placeholder="Enter department"
                      onChange={handleChange}
                      value={formData.department || ""}
                      disabled={isProcessing}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                    />
                  </div>
                </div>

                <div className="flex gap-2 items-center w-full">
                  <div className="text-gray-400 self-start pt-2">
                    <FiAlignLeft size={16} />
                  </div>
                  <div className="w-full">
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Description
                    </label>
                    <textarea
                      name="description"
                      placeholder="Enter Description"
                      onChange={handleChange}
                      value={formData.description || ""}
                      disabled={isProcessing}
                      rows="3"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                    ></textarea>
                  </div>
                </div>

                <div className="pt-2 border-t border-gray-100">
                  <div className="text-sm text-gray-500 mb-2 font-medium">
                    Location Information
                  </div>
                </div>

                <div className="flex gap-2 items-center w-full">
                  <div className="text-gray-400 self-start pt-2">
                    <FiMap size={16} />
                  </div>
                  <div className="w-full">
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Location *
                    </label>
                    <input
                      type="text"
                      name="location"
                      placeholder="Enter location of item"
                      onChange={handleChange}
                      value={formData.location || ""}
                      required
                      disabled={isProcessing}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                    />
                  </div>
                </div>

                <div className="flex gap-2 items-center w-full">
                  <div className="text-gray-400 self-start pt-2">
                    <FiUser size={16} />
                  </div>
                  <div className="w-full">
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Custodian
                    </label>
                    <input
                      type="text"
                      name="custodian"
                      placeholder="Enter name of custodian"
                      onChange={handleChange}
                      value={formData.custodian || ""}
                      disabled={isProcessing}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                    />
                  </div>
                </div>

                <div className="pt-2 border-t border-gray-100">
                  <div className="text-sm text-gray-500 mb-2 font-medium">
                    Quantity Information
                  </div>
                </div>

                <div className="flex gap-2 items-center w-full">
                  <div className="text-gray-400 self-start pt-2">
                    <FiHash size={16} />
                  </div>
                  <div className="w-full">
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Quantity *
                    </label>
                    <input
                      type="number"
                      name="quantity"
                      placeholder="Enter initial quantity"
                      onChange={handleChange}
                      value={formData.quantity || ""}
                      required
                      disabled={isProcessing}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                    />
                  </div>
                </div>

                <div className="flex gap-2 items-center w-full">
                  <div className="text-gray-400 self-start pt-2">
                    <FiTag size={16} />
                  </div>
                  <div className="w-full">
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Cost Per Unit
                    </label>
                    <input
                      type="number"
                      name="costPerUnit"
                      placeholder="Enter cost per unit"
                      onChange={handleChange}
                      value={formData.costPerUnit || ""}
                      disabled={isProcessing}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                    />
                  </div>
                </div>

                <div className="pt-4 mt-2">
                  <button
                    className="w-full py-2.5 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors"
                    style={{ backgroundColor: secondaryColor, color: "white" }}
                    onClick={handleSubmit}
                    disabled={isProcessing}
                  >
                    {isProcessing ? (
                      <>
                        <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                        <span>Processing...</span>
                      </>
                    ) : (
                      <>
                        <FiSave size={16} />
                        <span>Save Inventory Item</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Item Detail Modal */}
        {showDetailModal && selectedItem && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center p-4 border-b border-gray-100">
                <div className="flex items-center gap-2">
                  <div
                    className="p-2 rounded-lg"
                    style={{ backgroundColor: `${primaryColor}10` }}
                  >
                    <FiBox style={{ color: primaryColor }} />
                  </div>
                  <div>
                    <h2
                      className="text-base font-semibold"
                      style={{ color: primaryColor }}
                    >
                      {selectedItem.itemName}
                    </h2>
                    <p className="text-xs text-gray-500">
                      {selectedItem.category || "No category"}
                    </p>
                  </div>
                </div>
                <button
                  onClick={handleCloseDetailModal}
                  className="p-2 rounded-full hover:bg-gray-100 transition-colors"
                >
                  <FiX className="text-gray-500" />
                </button>
              </div>

              <div className="p-4">
                {/* Item Details */}
                <div className="mb-6">
                  <h3 className="text-sm font-medium text-gray-600 mb-3">
                    Item Details
                  </h3>

                  <div className="grid grid-cols-2 gap-3">
                    <div className="bg-gray-50 p-3 rounded-lg">
                      <div className="text-xs text-gray-500 mb-1">Location</div>
                      <div className="text-sm">
                        {selectedItem.location || "Not specified"}
                      </div>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                      <div className="text-xs text-gray-500 mb-1">
                        Custodian
                      </div>
                      <div className="text-sm">
                        {selectedItem.custodian || "Not assigned"}
                      </div>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                      <div className="text-xs text-gray-500 mb-1">
                        Initial Qty
                      </div>
                      <div className="text-sm">
                        {selectedItem.quantity || "0"} units
                      </div>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                      <div className="text-xs text-gray-500 mb-1">
                        Current Balance
                      </div>
                      <div
                        className="text-sm font-medium"
                        style={{
                          color: itemBalance > 0 ? secondaryColor : "red",
                        }}
                      >
                        {itemBalance} units
                      </div>
                    </div>
                    {selectedItem.costPerUnit && (
                      <div className="bg-gray-50 p-3 rounded-lg">
                        <div className="text-xs text-gray-500 mb-1">
                          Cost Per Unit
                        </div>
                        <div className="text-sm">
                          {selectedItem.costPerUnit}
                        </div>
                      </div>
                    )}
                    <div className="bg-gray-50 p-3 rounded-lg">
                      <div className="text-xs text-gray-500 mb-1">
                        Created On
                      </div>
                      <div className="text-sm">
                        {new Date(selectedItem.createdAt).toLocaleDateString()}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Description if exists */}
                {selectedItem.description && (
                  <div className="mb-6">
                    <h3 className="text-sm font-medium text-gray-600 mb-2">
                      Description
                    </h3>
                    <div className="bg-gray-50 p-3 rounded-lg text-sm">
                      {selectedItem.description}
                    </div>
                  </div>
                )}

                {/* Recent Transactions */}
                <div className="mb-6">
                  <h3 className="text-sm font-medium text-gray-600 mb-3">
                    Recent Transactions
                  </h3>

                  {itemTransactions.length === 0 ? (
                    <div className="text-center py-6 bg-gray-50 rounded-lg">
                      <FiPackage
                        className="mx-auto text-gray-300 mb-2"
                        size={24}
                      />
                      <p className="text-sm text-gray-500">
                        No transactions yet
                      </p>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {itemTransactions
                        .slice(0, 3)
                        .map((transaction, index) => (
                          <div
                            key={index}
                            className="bg-gray-50 p-3 rounded-lg"
                          >
                            <div className="flex justify-between items-start mb-2">
                              <div className="flex items-center">
                                <div
                                  className={`p-1.5 rounded-full mr-2 ${
                                    transaction.transactionType === "addition"
                                      ? "bg-green-100"
                                      : "bg-blue-100"
                                  }`}
                                >
                                  {transaction.transactionType ===
                                  "addition" ? (
                                    <FiPlus
                                      size={12}
                                      className="text-green-600"
                                    />
                                  ) : (
                                    <FiArrowRight
                                      size={12}
                                      className="text-blue-600"
                                    />
                                  )}
                                </div>
                                <div className="text-sm font-medium">
                                  {transaction.transactionType === "addition"
                                    ? "Addition"
                                    : "Issuance"}
                                </div>
                              </div>
                              <div className="text-xs text-gray-500">
                                {new Date(
                                  transaction.date || transaction.createdAt
                                ).toLocaleDateString()}
                              </div>
                            </div>
                            <div className="flex justify-between items-center">
                              <div className="text-sm">
                                {transaction.quantity} units{" "}
                                {transaction.transactionType === "issuance" &&
                                  `to ${transaction.issuedTo || "Unknown"}`}
                              </div>
                              <div className="text-xs px-2 py-1 rounded-full bg-gray-200">
                                {transaction.transactionType === "addition"
                                  ? "+"
                                  : "-"}
                                {transaction.quantity}
                              </div>
                            </div>
                            {transaction.remarks && (
                              <div className="text-xs text-gray-500 mt-1">
                                {transaction.remarks}
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  )}
                </div>

                {/* Issue Item Form */}
                <div className="border-t border-gray-100 pt-4">
                  <h3 className="text-sm font-medium text-gray-600 mb-3">
                    Issue Item
                  </h3>

                  {itemBalance <= 0 ? (
                    <div className="bg-red-50 border-l-4 border-red-500 p-3 mb-4">
                      <p className="text-sm text-red-700">
                        Cannot issue - no available stock
                      </p>
                    </div>
                  ) : (
                    <form onSubmit={handleIssuanceSubmit} className="space-y-4">
                      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 mb-4">
                        <p className="text-xs text-yellow-800">
                          Available quantity:{" "}
                          <span className="font-bold">{itemBalance}</span> units
                        </p>
                      </div>

                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Quantity to Issue *
                        </label>
                        <input
                          type="number"
                          name="quantity"
                          min="1"
                          max={itemBalance}
                          placeholder="Enter quantity"
                          onChange={handleIssuanceChange}
                          value={issuanceFormData.quantity || ""}
                          required
                          disabled={issuanceProcessing}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                        />
                      </div>

                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Issue Date *
                        </label>
                        <input
                          type="date"
                          name="date"
                          onChange={handleIssuanceChange}
                          value={issuanceFormData.date || ""}
                          required
                          disabled={issuanceProcessing}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                        />
                      </div>

                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Issued To *
                        </label>
                        {loadingUsers ? (
                          <div className="flex items-center justify-center py-2 bg-gray-50 rounded-md">
                            <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-transparent rounded-full mr-2"></div>
                            <span className="text-xs text-gray-500">
                              Loading users...
                            </span>
                          </div>
                        ) : (
                          <Select
                            options={adminUsers.map((user) => ({
                              value: user.email,
                              label: user.displayName || user.email,
                            }))}
                            isMulti
                            onChange={handleSelectedUserChange}
                            value={issuedToUsers}
                            isDisabled={issuanceProcessing}
                            className="text-sm"
                            placeholder="Select recipients"
                          />
                        )}
                      </div>

                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Purpose *
                        </label>
                        <input
                          type="text"
                          name="purpose"
                          placeholder="Enter purpose"
                          onChange={handleIssuanceChange}
                          value={issuanceFormData.purpose || ""}
                          required
                          disabled={issuanceProcessing}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                        />
                      </div>

                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Remarks
                        </label>
                        <textarea
                          name="remarks"
                          placeholder="Enter any additional notes"
                          rows="2"
                          onChange={handleIssuanceChange}
                          value={issuanceFormData.remarks || ""}
                          disabled={issuanceProcessing}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-[#363062]"
                        ></textarea>
                      </div>

                      <button
                        type="submit"
                        className="w-full py-2.5 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors"
                        style={{
                          backgroundColor: primaryColor,
                          color: "white",
                        }}
                        disabled={issuanceProcessing || itemBalance <= 0}
                      >
                        {issuanceProcessing ? (
                          <>
                            <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                            <span>Processing...</span>
                          </>
                        ) : (
                          <>
                            <FiArrowRight size={16} />
                            <span>Issue Item</span>
                          </>
                        )}
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </MobileWrapper>
  );
}

export default InventoryMobile;
